import { useTranslation } from "@impero-com/common/utils/i18n";
import { Cascader } from "antd";
import { DefaultOptionType } from "rc-cascader";

import { AdminEditViewAccessRights, UserOverview } from "api/generated/model";

import * as theme from "./AccessRightsFilterInput.css";
import { AccessRightKey } from "./types";
import { buildCascaderOptions } from "./utils";

export type AccessRightsFilterInputValue = Array<
    [AccessRightKey, number] | [AccessRightKey]
>;

interface AccessRightsFilterInputProps {
    facetedValues: Map<AdminEditViewAccessRights, number>;
    users: UserOverview[];
    value: AccessRightsFilterInputValue | null;
    onChange: (value: DefaultOptionType) => void;
}
export function AccessRightsFilterInput({
    facetedValues,
    onChange,
    users,
    value,
}: AccessRightsFilterInputProps) {
    const { t } = useTranslation();

    const accessRightLabelMap: Record<AccessRightKey, string> = {
        admin: t("AccessRights_Admin"),
        edit: t("AccessRights_Edit"),
        view: t("AccessRights_View"),
    };

    const cascaderOptions = buildCascaderOptions(
        facetedValues,
        users,
        accessRightLabelMap
    );

    return (
        <Cascader
            placeholder={t("FilterAccessRights_Placeholder")}
            allowClear
            multiple
            showSearch
            autoFocus
            dropdownMatchSelectWidth
            options={cascaderOptions}
            displayRender={(value) => value.join("  >  ")}
            className={theme.cascader}
            value={value ?? undefined}
            onChange={onChange}
        />
    );
}
